"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = void 0;
const normalize = (rawInput) => rawInput;
exports.normalize = normalize;
//# sourceMappingURL=helpers.js.map